export const register = {
    title: 'Register',
    passwordLabel: 'Password',
    confirmPassword: 'Confirm Password',
    buttonRegister: 'Sign Up',
    confirmPasswordLabel: 'Confirm Password',
    policy1: 'I agree with',
    policy2: 'Terms & Conditions',
    and: 'and',
    policy3: 'Privacy Policy.',
    backToLogin: 'Back to login',
    contentAfterRegister: 'Congratulations on successfully registering! Please check your email to verify your account. If you don\'t see the verification email in your inbox, please check your Spam folder.',
};
